import { useConnection } from 'wagmi';
import { getTokenIconUrl } from 'utils/url';
import React from 'react';
import { Body2 } from 'components/Typography';
import { TokenImage } from 'components/TokenImage';
import { useTokenBalance } from 'utils/hooks/useTokenBalance';
import { formatUnits } from 'viem';

interface Token {
  symbol: string;
  address: `0x${string}`;
}

interface InputBalanceLabelProps {
  token: Token;
  chainId: number;
}

export const InputBalanceLabel = (props: InputBalanceLabelProps) => {
  const { chainId, token } = props;

  return (
    <div className='flex flex-row items-center gap-1'>
      <Item token={token} chainId={chainId} />
    </div>
  );
};

interface ItemProps {
  token: Token;
  chainId: number;
}

const Item = (props: ItemProps) => {
  const { token, chainId } = props;
  const account = useConnection();

  const balance = useTokenBalance({
    address: account.address,
    token: token.address,
    chainId: chainId,
    query: {
      enabled: account.isConnected,
    },
  });

  if (balance.isLoading || balance.isError || !balance.data) {
    return null;
  }

  return (
    <div
      className={`flex flex-row gap-1 before:mt-[5px] before:h-[12px] before:w-[0.4px] before:bg-[#F7F8F8] before:content-[''] first:before:hidden `}
    >
      <Body2>{formatUnits(balance.data.value, balance.data.decimals)}</Body2>
      <TokenImage
        symbol={token.symbol}
        height={16}
        width={16}
        src={getTokenIconUrl(token.symbol)}
        alt={token.symbol}
      />
    </div>
  );
};
